import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useDialog } from '../dialog/DialogContext';
import { ExportDialog } from '../dialog/ExportDialog';
import { TitleButton } from './TitleButton';

export const ExportButton = ({ exportReq, entityName, disabled = false }) => {
  const { openDialog } = useDialog();

  const tooltip = entityName ? `Export ${entityName}` : 'Export';

  const openExportDialog = () => {
    let finalExportReq = typeof exportReq === 'function' ? exportReq() : exportReq;

    openDialog(ExportDialog, { data: finalExportReq });
  };

  return <TitleButton icon={fas.faArrowCircleDown} toolTip={tooltip} onClick={openExportDialog} disabled={disabled} />;
};
